import { Box } from '@mui/material'
import { LeadFormBuilder } from '../features/leadforms/LeadFormBuilder'

export default function LeadFormBuilderPage() {
  return (
    <Box sx={{ height: '100%' }}>
      <LeadFormBuilder />
    </Box>
  )
}
